import $ from 'jQuery';

export default function () {
	$(function() {
		three_column_articles();
	});

	const slickDefaults = {
		adaptiveHeight: false,
	};

	class ThreeColumnArticles {

    }

    function three_column_articles() {
        // Select all the cards
        var cards = document.querySelectorAll('.three-column-articles--column-card');

        // Check if any cards exist before adding event listeners
        if (cards.length > 0) {
            cards.forEach(function(card) {
                card.addEventListener('click', function(e) {
                    // Prevents propagation if the click is directly on a link within the card
                    if (e.target.tagName === 'A') return;

                    // Finds the link within the card
                    var link = card.querySelector('.three-column-articles--column-card--button a');
                    if (link) {
                        window.location.href = link.href; // Redirects to the URL of the link
                    }
                });
            });
        }
    }
}